module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/add-department-tickets/add-department-tickets.component.css
// module id = ./src/app/main-settings/add-department-tickets/add-department-tickets.component.css
// module chunks = main